import { useFlowsServicesResponses } from '@flows-ui/services/FlowServicesResponsesContext'
import { processStepContentElementText } from '@flows-ui/utils/processStepContentElementText'
import { useFormElementField } from '@flows-ui/utils/useFormElementField'
import type { TrackFn } from '@flows/configs/analytics/blurTracking'
import type { TextContent } from '@flows/core/i18n/types'
import type { FlowValues } from '@flows/core/types/stepTypes'

export const useFlowField = (
  props: {
    name: string
    flowValues: FlowValues
    label?: TextContent
    placeholder?: TextContent
    onBlur?: Parameters<typeof useFormElementField>[0]['onBlur']
    track?: TrackFn
  },
  t: Parameters<typeof processStepContentElementText>[0]
) => {
  const { field, visibleError, onBlur } = useFormElementField(props)
  const servicesResponses = useFlowsServicesResponses()
  const translateFunction = processStepContentElementText(t, {
    flowValues: props.flowValues,
    servicesResponses,
  })
  const translateOptional = (text: TextContent | undefined) =>
    text ? translateFunction(text) : undefined
  return {
    field,
    visibleError,
    onBlur,
    translateFunction,
    label: translateOptional(props.label),
    placeholder: translateOptional(props.placeholder),
  }
}
